export default "__VITE_ASSET__WVyL49li__"